module.exports = __webpack_public_path__ + "static/media/shuffle.361f9ec0.svg";